import React, { PropsWithChildren } from "react";
import { PostHogProvider } from 'posthog-js/react'
import { PostHogConfig } from "posthog-js";
import { REACT_APP_POSTHOG_KEY } from "./env";

const apiKey = REACT_APP_POSTHOG_KEY

const options: Partial<PostHogConfig> = {
  api_host: process.env.REACT_APP_POSTHOG_HOST,
  name: 'app-applicant',
}

const InitPostHog: React.FC<PropsWithChildren> = ({ children }) => {
  if (!apiKey) {
    console.warn('[InitPostHog] No PostHog API Key set, PostHog will not be initialized');
    return <>{children}</>;
  }
  
  if (!options.api_host) {
    console.warn('[InitPostHog] No PostHog API Host set, PostHog will not be initialized');
    return <>{children}</>;
  }

  return <PostHogProvider apiKey={apiKey} options={options}>{children}</PostHogProvider>
}

export default InitPostHog
